import * as React from 'react'
import { Row, Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMobile } from '@fortawesome/pro-duotone-svg-icons'

export const StepThree = ({ kedo, state }) => (
    <Row>
        <Col md={8}>
            <strong>{kedo.t('Preview')}</strong>
            <p>{kedo.t('step_three_description', { ns: 'secureshare' })}</p>
        </Col>
        <Col md={4}>
            <strong>{kedo.t('Recipients')}</strong>
            <ul>
                {state.contacts.map((r) => (
                    <li key={r.email}>
                        {r.email}{' '}
                        {r.mobile && <FontAwesomeIcon icon={faMobile} />}
                    </li>
                ))}
            </ul>
        </Col>
    </Row>
)
